import { FC, useState, createContext } from 'react';
import { skillsEvaluation } from 'src/services';
import { SkillEvaluation } from 'src/models/skill/skillEvaluation.model';
import { useTranslation } from 'react-i18next';
import { CURRENT_USER } from 'src/constants';
import { useContext } from 'react';
import { EaContext } from 'src/contexts/EaContext';

type SkillsLinguistiqueContext = {
	setSkillsLinguistique: () => any;
	setSkillsLinguistiqueDataContext: (dataValue) => void;
	skillsLinguistiqueDataKO: boolean;
	setSkillsLinguistiqueDataKOContext: (dataValue) => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SkillsLinguistiqueContext = createContext<SkillsLinguistiqueContext>(
	{} as SkillsLinguistiqueContext
);

export const SkillsLinguistiqueProvider: FC = ({ children }) => {
	const {
		idUser
	} = useContext(EaContext);
	const userData = JSON.parse(localStorage.getItem(CURRENT_USER));
	const [skillsLinguistiqueData, setSkillsLinguistiqueData] = useState<SkillEvaluation[]>(null);
	// check data
	const [skillsLinguistiqueDataKO, setSkillsLinguistiqueDataKO] = useState<boolean>(false);
	const setSkillsLinguistiqueDataKOContext = (dataValue) => {
		setSkillsLinguistiqueDataKO(dataValue);
	};
	const setSkillsLinguistiqueDataContext = (dataValue) => {
		// check data temp
		if (dataValue == null || dataValue.length == 0) {
			setSkillsLinguistiqueDataKO(false);
		}
		setSkillsLinguistiqueData(dataValue);
		// check data
		for (let i = 0; i < dataValue.length; i++) {
			if (idUser != 0) {
				if (idUser == userData.id) { // consultant
					if (dataValue[i].noteConsultant == 0 || dataValue[i].noteConsultant == null) {
						setSkillsLinguistiqueDataKO(true);
						break;
					} else {
						setSkillsLinguistiqueDataKO(false);
					}
				} else { // manager
					if (dataValue[i].noteManager == 0 || dataValue[i].noteManager == null) {
						setSkillsLinguistiqueDataKO(true);
						break;
					} else {
						setSkillsLinguistiqueDataKO(false);
					}
				}
			}
		}
	};
	const setSkillsLinguistique = async () => {
		let errorMessage = "";
		if (skillsLinguistiqueData != null) {
			await skillsEvaluation.updateALotSkillsEvaluationAsync(skillsLinguistiqueData).then(response => {
				if (!response.data.success) {
					errorMessage = '- ' + response.data.message;
				}
			}).catch(err => {
				errorMessage = '- ' + err.response.data.message;
			});
		}
		return errorMessage;
	}
	const { t } = useTranslation();
	return (
		<>
			<SkillsLinguistiqueContext.Provider value={{
				setSkillsLinguistique,
				setSkillsLinguistiqueDataContext,
				skillsLinguistiqueDataKO,
				setSkillsLinguistiqueDataKOContext
			}}>
				{children}
			</SkillsLinguistiqueContext.Provider>
		</>
	);
};
